import React from "react";
import NewAppVersionAvailable from "../other/NewAppVersionAvailable";
import { isAndroid, isIos } from "tools/device";
import { useGetState, useSetState } from "../ReduxProvider";
import { isSameDay } from "date-fns";
import { isApp } from "tools/device";
import { snackbar } from "tools/events";
import { useEffectOnce } from "react-use";

const parseAppVersion = (envVar?: string): number | undefined => {
  const v = Number(envVar);
  return isNaN(v) ? undefined : v;
};

// fill this in env variables based on the version of the app in the store
// (must be numbers like 12007 for version 12.0.7, same as in cordova's index.html)
const getIOSVersion = () => parseAppVersion(process.env.REACT_APP_VERSION_IOS);
const getAndroidVersion = () => parseAppVersion(process.env.REACT_APP_VERSION_ANDROID);
const getPlatformVersion = () => (isIos() ? getIOSVersion() : isAndroid() ? getAndroidVersion() : undefined);

const AppUpdateNotice: React.FC = () => {
  const lastShown = useGetState("appUpdateNoticeLastShown");
  const setLastShown = useSetState("appUpdateNoticeLastShown");

  useEffectOnce(() => {
    if (!isApp() || !window.appversion) return; // is not native app

    const appVersion = window.appversion;
    const envVersion = getPlatformVersion();
    if (lastShown && isSameDay(new Date(lastShown), new Date())) return;
    if (!envVersion || envVersion <= appVersion) return; // no update needed

    setLastShown(Date.now());
    snackbar(<NewAppVersionAvailable />, { severity: "info", autoHide: false });
  });

  return null;
};

export default AppUpdateNotice;
